export const ANALYTICS_USER_EVENT = 'ANALYTICS_USER_EVENT';
export const ANALYTICS_IDENTIFY_USER = 'ANALYTICS_IDENTIFY_USER';
export const ANALYTICS_RESET_USER = 'ANALYTICS_RESET_USER';
export const ANALYTICS_LOCATION_CHANGED = 'ANALYTICS_LOCATION_CHANGED';
export const ANALYTICS_SET_GROUP = 'ANALYTICS_SET_GROUP';
